module.exports = __webpack_public_path__ + "static/img/active4.da837369.png";